<template>
	<div ref="chart" class="line-chart"></div>
</template>

<script>
	import * as echarts from 'echarts';

	export default {
		name: "LineChart",
		props: {
			xData: {
				type: Array,
				default: () => []
			},
			yData: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {
				chart: null
			};
		},
		mounted() {
			this.initChart();
			window.addEventListener("resize", this.resizeChart);
		},
		beforeDestroy() {
			if (this.chart) {
				this.chart.dispose();
			}
			window.removeEventListener("resize", this.resizeChart);
		},
		watch: {
			xData: "updateChart",
			yData: "updateChart"
		},
		methods: {
			initChart() {
				this.chart = echarts.init(this.$refs.chart);
				this.setOption();
			},
			setOption() {
				const option = {
					xAxis: {
						type: "category",
						boundaryGap: false,
						data: this.xData,
						// splitLine: {
						//     show: true,
						//     lineStyle: {
						//         type: 'dashed' // 设置X轴网格线为虚线
						//     }
						// }
					},
					yAxis: {
						type: "value",
						scale: true,
						splitLine: {
							show: true,
							lineStyle: {
								type: 'dashed', // 设置X轴网格线为虚线
								color: '#565e70'
							}
						}

					},
					grid: {
						top: 30,
						bottom: 20,
						left: 0,
						containLabel: true
					},
					series: [{
						data: this.yData,
						type: "line",
						areaStyle: {},
					}],
					dataZoom: [{
						type: "inside",
						smooth: true, // 建议加上平滑过渡，让折线更美观
						symbol: 'none', // 如果数据点密集，可以隐藏圆点
						zoomOnMouseWheel: false, // 禁止滚轮缩放
						moveOnMouseWheel: false, // 禁止滚轮平移
						moveOnMouseMove: false, // 禁止拖动
						preventDefaultMouseMove: false,
					}, ],
				};
				this.chart.setOption(option);
			},
			updateChart() {
				if (this.chart) {
					this.setOption();
				}
			},
			resizeChart() {
				if (this.chart) {
					this.chart.resize();
				}
			}
		}
	};
</script>

<style scoped>
	.line-chart {
		width: 100%;
		height: 40vh;
	}
</style>